var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('person-registration-candidate-search-input',{attrs:{"allow-unexisting":_vm.allowUnexisting,"allow-save":_vm.allowSave,"disabled":_vm.disabled,"course-event-ref":_vm.courseEventRef},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }